import { createApiCallActions } from '../../../../common/store/generic.actions';
import { ListItem } from '../../typeahead/types';
import { AttendanceRegularityModel } from './types';

export const userWorkAttendanceActions = {
  getRegularity: createApiCallActions<AttendanceRegularityModel>(
    'userWorkAttendance',
    'getRegularity',
  ),
  getUsers: createApiCallActions<ListItem[]>('userWorkAttendance', 'getUsers'),
  getSalesPersonRegularity: createApiCallActions<AttendanceRegularityModel>(
    'userWorkAttendance',
    'getSalesPersonRegularity',
  ),
  getSalesPersonUsers: createApiCallActions<ListItem[]>(
    'userWorkAttendance',
    'getSalesPersonUsers',
  ),
};

export type UserWorkAttendanceAction = typeof userWorkAttendanceActions;
